<template>
  <div>
    <section>
      <v-container>
        <v-row justify="center">
          <v-col cols="12" sm="10" lg="12">
            <h1
              :class="($vuetify.breakpoint.mdAndDown && 'display-1 font-weight-black') || 'main-title'"
              class="gadient-text text-center py-10rem"
            >
              User Profile plugin would not be built without most ♥ generous photographers from
              <v-img
                style="margin: auto"
                :width="($vuetify.breakpoint.mdAndDown && 168) || 378"
                class="unsplash-logo mt-4"
                :src="require(`@/assets/icons/unsplash_logo_full.svg`)"
                :lazy-src="require(`@/assets/icons/unsplash_logo_full.svg`)"
              ></v-img>
            </h1>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section>
      <v-container
        :grid-list-xl="$vuetify.breakpoint.smAndUp"
        :grid-list-md="$vuetify.breakpoint.smAndDown"
        class="mt-5"
      >
        <div class="d-flex flex-row align-sm-center justify-sm-center mb-10">
          <v-toolbar-title class="d-none d-sm-block">Photo Credits:</v-toolbar-title>
          <v-spacer class="d-none d-sm-block" />
          <v-text-field
            v-model="photoSearch"
            label="Search by author name"
            prepend-icon="mdi-magnify"
            hide-details="auto"
            color="primary"
            solo
          ></v-text-field>
        </div>
        <v-row>
          <v-col v-for="(photo, index) in filtedPhotos" :key="index" cols="4" sm="3" md="2" class="text-center">
            <v-img
              class="rounded-circle"
              :src="photo.url"
              :lazy-src="photo.url"
              aspect-ratio="1"
              style="cursor: pointer"
              @click="photoSelect(photo)"
            ></v-img>
            <div class="text-wrapper">
              <span class="grey--text mr-1">By</span>
              <span v-if="photo.userName.substring(10)" style="cursor: pointer" @click="userLink(photo)">
                {{ photo.userName.substring(0, 9) }}...
              </span>
              <span v-else style="cursor: pointer" @click="userLink(photo)">{{ photo.userName }}</span>
            </div>
            <span class="grey--text mx-1">on</span>
            <span style="cursor: pointer" class="grey--text" @click="UnsplashLink()">Unsplash</span>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <infinite-loading @infinite="infiniteHandler" ref="infiniteLoading">
      <div slot="spinner" class="mb-20rem">
        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
      </div>
      <v-container slot="no-more">
        <!-- {{this.totalPhotos}} -->
        <template v-if="this.totalPhotos > this.loadPages * 10">
          <v-btn @click="laodMorePhotos()" rounded>Load more</v-btn>
        </template>
        <v-row justify="center" class="my-10">
          <v-col cols="12" sm="6" class="text-center">
            <v-sheet rounded color="#0c0c0c" class="pa-5 rounded-pill">
              <h1 class="display-2 font-weight-black gadient-text">
                <template v-if="this.totalPhotos > this.loadPages * 10">+ {{ totalPhotosShowed }} photos</template>
                <template v-else>Total {{ this.totalPhotos }} photos</template>
              </h1>
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
      <v-container slot="no-results">
        <v-row justify="center" class="my-10">
          <v-col cols="12" sm="6" class="text-center">
            <v-sheet rounded color="#0c0c0c" class="pa-10 rounded-pill">
              <h1 :class="($vuetify.breakpoint.mdAndDown && 'display-1') || 'display-3'">
                Error ... 🤔 can not get photos
              </h1>
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </infinite-loading>
  </div>
</template>

<script>
import axios from 'axios'
import InfiniteLoading from 'vue-infinite-loading'

export default {
  components: {
    'infinite-loading': InfiniteLoading,
  },
  data: () => ({
    photoSearch: '',
    page: 1,
    loadPages: 3,
    list: [],
    totalPhotos: '',
  }),
  computed: {
    filtedPhotos() {
      return this.list.filter((list) => {
        return list.userName.toLowerCase().match(this.photoSearch.toLowerCase())
      })
    },
    totalPhotosShowed() {
      return this.totalPhotos - this.page * 10
    },
  },
  methods: {
    photoSelect(photo) {
      window.open(photo.link, '_blank')
    },
    userLink(photo) {
      window.open(photo.userLink, '_blank')
    },
    laodMorePhotos() {
      this.loadPages += 10
      this.$refs.infiniteLoading.stateChanger.reset()
    },
    UnsplashLink(photo) {
      window.open(
        'https://unsplash.com/collections/3678902/profile/?utm_source=user_profile_plugin&utm_medium=referral',
        '_blank',
      )
    },
    infiniteHandler(state) {
      axios
        .get('https://awesome-app-api.herokuapp.com/photos', {
          params: {
            page: this.page,
          },
        })
        .then(({data}) => {
          this.totalPhotos = data.total_photos
          if (data.data.length) {
            this.page += 1
            this.list.push(...data.data)
            state.loaded()
          } else {
            state.complete()
          }
          if (this.page > this.loadPages) {
            state.complete()
          }
        })
        .catch((err) => {
          state.complete()
          console.log(err)
        })
    },
  },
}
</script>

<style scoped>
.text-wrapper {
  white-space: nowrap;
}
.unsplash-logo {
  /* display: inline-block; */
}
</style>
